import React, { useState, useEffect, useCallback } from 'react';
import api from '../services/api';
import { useSocket } from '../hooks/useSocket';

const C = {
  bg:'#0f172a', bg2:'#1e293b', bg3:'#0f172a',
  border:'#334155', text:'#f1f5f9', sub:'#94a3b8', muted:'#475569',
  blue:'#0ea5e9', green:'#22c55e', yellow:'#f59e0b', red:'#ef4444', purple:'#8b5cf6'
};

const s = {
  page:   { maxWidth: 900 },
  title:  { fontSize:22, fontWeight:600, color:C.text, marginBottom:4 },
  sub:    { fontSize:13, color:C.muted, marginBottom:24 },
  grid3:  { display:'grid', gridTemplateColumns:'repeat(3,1fr)', gap:12, marginBottom:24 },
  kpi:    { background:C.bg2, border:`1px solid ${C.border}`, borderRadius:10, padding:16 },
  kpiV:   (c=C.blue) => ({ fontSize:26, fontWeight:700, color:c }),
  kpiL:   { fontSize:11, color:C.muted, marginTop:2 },
  card:   { background:C.bg2, border:`1px solid ${C.border}`, borderRadius:12,
            marginBottom:14, overflow:'hidden' },
  hdr:    { display:'flex', alignItems:'center', justifyContent:'space-between',
            padding:'14px 18px', borderBottom:`1px solid ${C.border}` },
  bdy:    { padding:'16px 18px' },
  name:   { fontSize:15, fontWeight:600, color:C.text },
  inst:   { fontSize:11, color:C.muted, marginTop:2 },
  badge:  (c) => ({ background:c+'22', color:c, padding:'3px 12px',
                    borderRadius:12, fontSize:12, fontWeight:600 }),
  btnAtivar:   { background:C.green, color:'#fff', border:'none', borderRadius:8,
                 padding:'8px 18px', cursor:'pointer', fontSize:13, fontWeight:600 },
  btnDesativar:{ background:'transparent', color:C.red,
                 border:`1px solid rgba(239,68,68,.4)`,
                 borderRadius:8, padding:'8px 18px', cursor:'pointer', fontSize:13 },
  btnSm:  { background:C.bg2, color:C.sub, border:`1px solid ${C.border}`,
            borderRadius:8, padding:'5px 12px', cursor:'pointer', fontSize:12 },
  label:  { fontSize:12, color:C.sub, marginBottom:5, display:'block' },
  input:  { width:'100%', background:C.bg3, border:`1px solid ${C.border}`,
            borderRadius:8, padding:'9px 12px', color:C.text, fontSize:13,
            outline:'none', marginBottom:12, fontFamily:'inherit' },
  tarea:  { width:'100%', background:C.bg3, border:`1px solid ${C.border}`,
            borderRadius:8, padding:'9px 12px', color:C.text, fontSize:13,
            outline:'none', marginBottom:12, resize:'vertical', minHeight:70,
            fontFamily:'inherit' },
  sel:    { width:'100%', background:C.bg3, border:`1px solid ${C.border}`,
            borderRadius:8, padding:'9px 12px', color:C.text, fontSize:13, marginBottom:12 },
  grid2:  { display:'grid', gridTemplateColumns:'1fr 1fr', gap:12 },
  hr:     { border:'none', borderTop:`1px solid ${C.border}`, margin:'14px 0' },
  ok:     { background:'rgba(34,197,94,.1)', color:'#4ade80', borderRadius:8,
            padding:'10px 14px', fontSize:13, marginBottom:12 },
  err:    { background:'rgba(239,68,68,.1)', color:'#f87171', borderRadius:8,
            padding:'10px 14px', fontSize:13, marginBottom:12 },
  alertBox:{ display:'flex', alignItems:'center', gap:8, padding:'10px 14px',
             borderRadius:8, fontSize:13, background:'rgba(245,158,11,.08)',
             border:`1px solid rgba(245,158,11,.25)`, color:C.yellow, marginBottom:12 },
  detalhe:{ background:C.bg3, borderRadius:8, padding:'12px 14px', marginTop:10 },
  convRow:{ padding:'8px 0', borderBottom:`1px solid #1e293b`, display:'flex',
            alignItems:'center', justifyContent:'space-between' },
  intRow: { padding:'8px 0', borderBottom:`1px solid #1e293b` },
  intDir: (d) => ({
            fontSize:11, color: d==='in'?C.green:C.blue, marginBottom:2,
            fontWeight:600
          }),
  intTxt: { fontSize:13, color:C.text, lineHeight:1.5 },
  intRsp: { fontSize:12, color:C.sub, marginTop:4, paddingLeft:12,
            borderLeft:`2px solid ${C.border}` },
};

const MOTIVO_LABEL = {
  ausencia:'Ausência', ferias:'Férias', demissao:'Demissão',
  doenca:'Doença/Licença', outro:'Outro'
};

// ── Formulário de ativação ────────────────────────────────────────
function FormAtivar({ atendente, onSalvo, onCancelar }) {
  const [form, setForm] = useState({
    motivo: 'ausencia', observacao: '', previsao_retorno: '',
    nome_agente: 'Equipe D1 Carreiras',
    msg_humano_solicitado: 'No momento nosso atendimento está temporariamente reduzido. Assim que possível um atendente entrará em contato. Posso te ajudar com algo enquanto isso? 😊',
    msg_encerramento: 'Obrigado pelo contato! Em breve nossa equipe estará completa novamente. 😊',
    tom: 'profissional', max_trocas_ia: 10,
    gemini_api_key: '', gemini_model: 'gemini-2.5-flash',
    system_prompt: ''
  });
  const [saving, setSaving] = useState(false);
  const [msg, setMsg]       = useState(null);

  const salvar = async () => {
    setSaving(true); setMsg(null);
    try {
      await api.post(`/substituto/${atendente.id}/ativar`, form);
      setMsg({ ok:true, txt:'Agente substituto ativado!' });
      setTimeout(onSalvo, 1000);
    } catch (e) {
      setMsg({ ok:false, txt: e.response?.data?.error || 'Erro ao ativar' });
    } finally { setSaving(false); }
  };

  return (
    <div style={s.bdy}>
      <div style={s.alertBox}>
        ⚠️ Ao ativar, o atendente <strong>{atendente.name}</strong> ficará inativo
        e o agente de IA assumirá as mensagens do número <strong>{atendente.instance_name}</strong>.
      </div>
      {msg && <div style={msg.ok?s.ok:s.err}>{msg.txt}</div>}

      <div style={s.grid2}>
        <div>
          <label style={s.label}>Motivo da ausência</label>
          <select style={s.sel} value={form.motivo} onChange={e=>setForm(f=>({...f,motivo:e.target.value}))}>
            {Object.entries(MOTIVO_LABEL).map(([k,v])=><option key={k} value={k}>{v}</option>)}
          </select>
        </div>
        <div>
          <label style={s.label}>Previsão de retorno (opcional)</label>
          <input style={s.input} type="date" value={form.previsao_retorno}
            onChange={e=>setForm(f=>({...f,previsao_retorno:e.target.value}))} />
        </div>
      </div>

      <label style={s.label}>Observação interna (não aparece para clientes)</label>
      <input style={s.input} value={form.observacao} placeholder="ex: viagem de trabalho, férias programadas..."
        onChange={e=>setForm(f=>({...f,observacao:e.target.value}))} />

      <div style={s.hr} />
      <div style={{ fontSize:13, fontWeight:600, color:C.sub, marginBottom:10 }}>🤖 Configuração do Agente</div>

      <label style={s.label}>Nome do agente (como vai se apresentar)</label>
      <input style={s.input} value={form.nome_agente}
        onChange={e=>setForm(f=>({...f,nome_agente:e.target.value}))} />

      <label style={s.label}>Tom de comunicação</label>
      <select style={s.sel} value={form.tom} onChange={e=>setForm(f=>({...f,tom:e.target.value}))}>
        <option value="profissional">Profissional</option>
        <option value="amigavel">Amigável</option>
        <option value="formal">Formal</option>
      </select>

      <label style={s.label}>Resposta quando cliente pede atendente humano</label>
      <textarea style={s.tarea} value={form.msg_humano_solicitado}
        onChange={e=>setForm(f=>({...f,msg_humano_solicitado:e.target.value}))} />

      <label style={s.label}>Mensagem de encerramento (quando atinge limite)</label>
      <textarea style={s.tarea} value={form.msg_encerramento}
        onChange={e=>setForm(f=>({...f,msg_encerramento:e.target.value}))} />

      <div style={s.grid2}>
        <div>
          <label style={s.label}>Máx. respostas por conversa/dia</label>
          <input style={s.input} type="number" min="3" max="50" value={form.max_trocas_ia}
            onChange={e=>setForm(f=>({...f,max_trocas_ia:parseInt(e.target.value)}))} />
        </div>
        <div>
          <label style={s.label}>Modelo Gemini</label>
          <select style={s.sel} value={form.gemini_model}
            onChange={e=>setForm(f=>({...f,gemini_model:e.target.value}))}>
            <option value="gemini-2.5-flash">gemini-2.5-flash (recomendado)</option>
            <option value="gemini-1.5-flash">gemini-1.5-flash (legado)</option>
            <option value="gemini-2.0-flash">gemini-2.0-flash</option>
          </select>
        </div>
      </div>

      <label style={s.label}>Chave Gemini do substituto deste atendente</label>
      <input style={s.input} type="password" value={form.gemini_api_key}
        placeholder="Cole a chave Gemini deste atendente, ou deixe vazio para usar a global"
        onChange={e=>setForm(f=>({...f,gemini_api_key:e.target.value}))} />
      <div style={{ color:'#64748b', fontSize:12, marginTop:-8, marginBottom:12 }}>
        Esta chave e usada quando o Substituto IA assume as conversas deste numero.
      </div>

      <label style={s.label}>
        Prompt personalizado (opcional — deixe vazio para usar o padrão profissional)
      </label>
      <textarea style={{ ...s.tarea, minHeight:90 }} value={form.system_prompt}
        placeholder="Deixe em branco para usar o prompt padrão da empresa..."
        onChange={e=>setForm(f=>({...f,system_prompt:e.target.value}))} />

      <div style={{ display:'flex', gap:10, marginTop:4 }}>
        <button style={s.btnAtivar} onClick={salvar} disabled={saving}>
          {saving ? 'Ativando...' : '✓ Ativar agente substituto'}
        </button>
        <button style={s.btnSm} onClick={onCancelar}>Cancelar</button>
      </div>
    </div>
  );
}

// ── Card de atendente ─────────────────────────────────────────────
function CardAtendente({ atendente, onRefresh }) {
  const [expandido, setExp]     = useState(false);
  const [ativando, setAtivando] = useState(false);
  const [conversas, setConvs]   = useState([]);
  const [interacoes, setInts]   = useState([]);
  const [msg, setMsg]           = useState(null);

  const subAtivo = atendente.sub_ativo;

  const carregarDetalhes = async () => {
    if (!subAtivo) return;
    try {
      const [c, i] = await Promise.all([
        api.get(`/substituto/${atendente.id}/conversas-abertas`),
        api.get(`/substituto/${atendente.id}/interacoes?limit=10`)
      ]);
      setConvs(c.data); setInts(i.data);
    } catch {}
  };

  const desativar = async () => {
    if (!window.confirm(`Desativar o agente substituto de ${atendente.name}?`)) return;
    try {
      await api.post(`/substituto/${atendente.id}/desativar`);
      setMsg({ ok:true, txt:'Substituto desativado. Atendente reativado.' });
      setTimeout(onRefresh, 1000);
    } catch (e) {
      setMsg({ ok:false, txt: e.response?.data?.error || 'Erro' });
    }
  };

  useEffect(() => { if (expandido) carregarDetalhes(); }, [expandido]);

  const fmtData = d => d ? new Date(d).toLocaleString('pt-BR') : '–';

  return (
    <div style={s.card}>
      <div style={s.hdr}>
        <div>
          <div style={s.name}>
            <span style={{ marginRight:8 }}>{subAtivo ? '🤖' : '👤'}</span>
            {atendente.name}
          </div>
          <div style={s.inst}>{atendente.instance_name || 'sem instância'}</div>
        </div>

        <div style={{ display:'flex', alignItems:'center', gap:10 }}>
          {subAtivo ? (
            <>
              <span style={s.badge(C.purple)}>
                🤖 IA ativa · {MOTIVO_LABEL[atendente.motivo] || atendente.motivo}
              </span>
              {atendente.interacoes_hoje > 0 && (
                <span style={s.badge(C.blue)}>{atendente.interacoes_hoje} msgs hoje</span>
              )}
              {atendente.pediram_humano_hoje > 0 && (
                <span style={s.badge(C.red)}>⚠️ {atendente.pediram_humano_hoje} pediram humano</span>
              )}
              <button style={s.btnSm} onClick={() => { setExp(!expandido); }}>
                {expandido ? '▲' : '▼'} Detalhes
              </button>
              <button style={s.btnDesativar} onClick={desativar}>Desativar IA</button>
            </>
          ) : (
            <>
              <span style={s.badge(atendente.active ? C.green : C.muted)}>
                {atendente.active ? 'Ativo' : 'Inativo'}
              </span>
              <button style={s.btnAtivar} onClick={() => setAtivando(!ativando)}>
                {ativando ? '✕ Cancelar' : '🤖 Ativar substituto'}
              </button>
            </>
          )}
        </div>
      </div>

      {msg && <div style={{ ...( msg.ok?s.ok:s.err ), margin:'0 18px 12px' }}>{msg.txt}</div>}

      {/* Formulário de ativação */}
      {ativando && !subAtivo && (
        <FormAtivar
          atendente={atendente}
          onSalvo={() => { setAtivando(false); onRefresh(); }}
          onCancelar={() => setAtivando(false)}
        />
      )}

      {/* Detalhes do substituto ativo */}
      {subAtivo && expandido && (
        <div style={s.bdy}>
          <div style={{ display:'flex', gap:20, marginBottom:14, flexWrap:'wrap' }}>
            <div><span style={{ color:C.muted, fontSize:12 }}>Ativado em: </span>
              <span style={{ fontSize:13, color:C.text }}>{fmtData(atendente.ativado_em)}</span></div>
            <div><span style={{ color:C.muted, fontSize:12 }}>Por: </span>
              <span style={{ fontSize:13, color:C.text }}>{atendente.ativado_por_nome || '–'}</span></div>
            <div><span style={{ color:C.muted, fontSize:12 }}>Retorno previsto: </span>
              <span style={{ fontSize:13, color:C.text }}>
                {atendente.previsao_retorno
                  ? new Date(atendente.previsao_retorno).toLocaleDateString('pt-BR')
                  : 'Não definido'}
              </span></div>
            <div><span style={{ color:C.muted, fontSize:12 }}>Agente: </span>
              <span style={{ fontSize:13, color:C.text }}>{atendente.nome_agente}</span></div>
          </div>

          {atendente.observacao && (
            <div style={{ fontSize:12, color:C.sub, marginBottom:14,
              background:C.bg3, padding:'8px 12px', borderRadius:6 }}>
              📋 {atendente.observacao}
            </div>
          )}

          {/* Conversas abertas */}
          {conversas.length > 0 && (
            <>
              <div style={{ fontSize:13, fontWeight:600, color:C.sub, marginBottom:8 }}>
                Conversas em andamento ({conversas.length})
              </div>
              <div style={s.detalhe}>
                {conversas.map((c,i) => (
                  <div key={i} style={s.convRow}>
                    <div>
                      <div style={{ fontSize:13, color:C.text }}>
                        {c.contato_nome || c.phone}
                        {c.contato_nome && <span style={{ color:C.muted, fontSize:11, marginLeft:6 }}>{c.phone}</span>}
                      </div>
                      <div style={{ fontSize:11, color:C.muted, marginTop:2 }}>
                        {c.total_msgs} mensagens · última {fmtData(c.ultima_msg)}
                      </div>
                    </div>
                    <div style={{ display:'flex', gap:8, alignItems:'center' }}>
                      <span style={s.badge(C.blue)}>{c.trocas_hoje} hoje</span>
                      {c.pediu_humano && <span style={s.badge(C.red)}>⚠️ quer humano</span>}
                    </div>
                  </div>
                ))}
              </div>
            </>
          )}

          {/* Últimas interações */}
          {interacoes.length > 0 && (
            <>
              <div style={{ fontSize:13, fontWeight:600, color:C.sub, margin:'14px 0 8px' }}>
                Últimas interações
              </div>
              <div style={s.detalhe}>
                {interacoes.map(i => (
                  <div key={i.id} style={s.intRow}>
                    <div style={s.intDir(i.direction)}>
                      {i.direction==='in' ? '⬇ Cliente' : '⬆ Agente IA'}
                      <span style={{ color:C.muted, fontWeight:400, marginLeft:8 }}>
                        {i.phone} · {fmtData(i.created_at)}
                      </span>
                    </div>
                    {i.mensagem_cliente &&
                      <div style={s.intTxt}>{i.mensagem_cliente}</div>}
                    {i.resposta_ia &&
                      <div style={s.intRsp}>{i.resposta_ia}</div>}
                    {i.tipo !== 'resposta' &&
                      <span style={{ ...s.badge(i.tipo==='pediu_humano'?C.red:C.yellow),
                        display:'inline-block', marginTop:4 }}>
                        {i.tipo.replace(/_/g,' ')}
                      </span>}
                  </div>
                ))}
              </div>
            </>
          )}
        </div>
      )}
    </div>
  );
}

// ── Página principal ──────────────────────────────────────────────
export default function Substituto() {
  const { socket } = useSocket();
  const [atendentes, setAt] = useState([]);
  const [stats, setStats]   = useState(null);
  const [loading, setLoad]  = useState(true);

  const carregar = useCallback(() => {
    setLoad(true);
    Promise.all([
      api.get('/substituto'),
      api.get('/substituto/stats/geral')
    ]).then(([r1, r2]) => {
      setAt(r1.data);
      setStats(r2.data);
    }).finally(() => setLoad(false));
  }, []);

  useEffect(() => { carregar(); }, [carregar]);

  useEffect(() => {
    if (!socket) return;
    socket.on('substituto_ativado',   carregar);
    socket.on('substituto_desativado',carregar);
    socket.on('substituto_respondeu', carregar);
    return () => {
      socket.off('substituto_ativado',   carregar);
      socket.off('substituto_desativado',carregar);
      socket.off('substituto_respondeu', carregar);
    };
  }, [socket, carregar]);

  const ativos   = atendentes.filter(a => a.sub_ativo);
  const inativos = atendentes.filter(a => !a.sub_ativo);

  return (
    <div style={s.page}>
      <div style={s.title}>Agente Substituto</div>
      <div style={s.sub}>
        Quando um atendente não puder trabalhar, o Gemini assume as conversas do número dele
      </div>

      {stats && (
        <div style={s.grid3}>
          <div style={s.kpi}>
            <div style={s.kpiV(C.purple)}>{stats.substitutos_ativos || 0}</div>
            <div style={s.kpiL}>Substitutos ativos agora</div>
          </div>
          <div style={s.kpi}>
            <div style={s.kpiV(C.blue)}>{stats.interacoes_hoje || 0}</div>
            <div style={s.kpiL}>Mensagens respondidas hoje</div>
          </div>
          <div style={s.kpi}>
            <div style={s.kpiV(stats.pediram_humano_hoje > 0 ? C.red : C.green)}>
              {stats.pediram_humano_hoje || 0}
            </div>
            <div style={s.kpiL}>Clientes que pediram humano</div>
          </div>
        </div>
      )}

      {loading && (
        <div style={{ color:C.muted, textAlign:'center', padding:40 }}>Carregando...</div>
      )}

      {ativos.length > 0 && (
        <>
          <div style={{ fontSize:14, fontWeight:600, color:C.purple, marginBottom:10 }}>
            🤖 Substitutos ativos ({ativos.length})
          </div>
          {ativos.map(a => <CardAtendente key={a.id} atendente={a} onRefresh={carregar} />)}
        </>
      )}

      {inativos.length > 0 && (
        <>
          <div style={{ fontSize:14, fontWeight:600, color:C.sub, marginBottom:10, marginTop:ativos.length?20:0 }}>
            👤 Atendentes disponíveis ({inativos.length})
          </div>
          {inativos.map(a => <CardAtendente key={a.id} atendente={a} onRefresh={carregar} />)}
        </>
      )}

      {!loading && atendentes.length === 0 && (
        <div style={{ color:C.muted, textAlign:'center', padding:40, fontSize:13 }}>
          Nenhum atendente cadastrado ainda.
        </div>
      )}
    </div>
  );
}
